import React, { useState } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { Alert, Button, Box } from '@mui/material'
import axios from 'axios'

import { WrappedCard as RegistrationCard } from '../registration/RegistrationCard'
import PasswordInput from '../registration/PasswordInput'

const ResetPassword = () => {
  const { code } = useParams()
  const [password, setPassword] = useState('')
  const [confirmedPassword, setConfirmedPassword] = useState('')
  const [mismatchError, setMismatchError] = useState(false)
  const [passwordReqError, setPasswordReqError] = useState(false)
  const [submitError, setSubmitError] = useState(false)
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const navigate = useNavigate()

  const handleReset = () => {
    setMismatchError(false)
    setSubmitError(false)
    setSubmitSuccess(false)

    if (password !== confirmedPassword) {
      setMismatchError(true)
      return
    }

    axios
      .put('/api/auth/reset-password', { code, password })
      .then(() => setSubmitSuccess(true))
      .catch((error) => {
        setSubmitError(true)
      })
  }

  const navigateBackToLogin = () => navigate('/login')

  const checkPassword = () => {
    if (!password || !confirmedPassword) return
    if (password !== confirmedPassword) return setPasswordMismatch(true)

    if (password.match(PASSWORD_REGEX) || password.length < 10) {
      setPasswordReqsExpanded(true)
      return setPasswordReqError(true)
    }
  }

  return (
    <RegistrationCard title={'Reset Password'}>
      {!submitSuccess && (
        <PasswordInput
          password={password}
          confirmedPassword={confirmedPassword}
          mismatchError={mismatchError}
          setMismatchError={setMismatchError}
          setPassword={setPassword}
          passwordReqError={passwordReqError}
          setPasswordReqError={setPasswordReqError}
          setConfirmedPassword={setConfirmedPassword}
          autoFocus
        ></PasswordInput>
      )}
      {submitSuccess && (
        <Alert sx={{ mt: '8px' }} severity='success'>
          Password successfully reset!
        </Alert>
      )}

      {submitError && (
        <Alert sx={{ mt: '8px' }} severity='error'>
          An error occured. Please try again <br /> later or{' '}
          <Link to='/forgot'>request another password reset email</Link>
        </Alert>
      )}

      <Box sx={{ mt: '16px', display: 'flex', justifyContent: 'flex-end' }}>
        {submitSuccess && (
          <Button onClick={navigateBackToLogin}>Back to Login</Button>
        )}

        {!submitSuccess && (
          <Button
            variant='contained'
            disabled={
              !password ||
              !confirmedPassword ||
              password.length !== confirmedPassword.length ||
              password.length < 10 ||
              mismatchError ||
              passwordReqError
            }
            onClick={() => handleReset()}
          >
            Reset Password
          </Button>
        )}
      </Box>
    </RegistrationCard>
  )
}

export default ResetPassword
